import React from "react";
import "./contactUsAndDonation.css";
import qrCode from "../../../../assets/mediqnow_qr.png"; // Replace with your actual QR code image

function ContactUsAndDonation() {
  return (
    <section  id="contact_us" className="contact-donation">
      <div className="contact-us">
        <h2>Contact <span>Us</span></h2>
        <p>We'd love to hear from you. Reach out for any questions or feedback.</p>
        <form>
          <input type="text" placeholder="Your Name" required />
          <input type="email" placeholder="Your Email" required />
          <textarea placeholder="Your Message" rows="5" required />
          <button type="submit">Send Message</button>
        </form>
      </div>

      <div className="donation">
        <h2>Support <span>MediQNow</span></h2>
        <p>Your contribution helps us make healthcare more accessible for everyone.</p>
        <div className="qr-box">
          <img src={qrCode} alt="Donate via QR Code" />
          <p>Scan to Donate</p>
        </div>
      </div>
    </section>
  );
}

export default ContactUsAndDonation;
